import { useCalender } from "../../../context/calendar/calendar-context";
import { Day } from "../day";

import type { CalendarDayType } from "../../root/use-initialize/utils";

type Props = {
	dateRangeArray: CalendarDayType[];
};

export const Table = ({ dateRangeArray }: Props) => {
	const { mode } = useCalender();

	return (
		<div className="grid grid-cols-7 gap-[2px]">
			{dateRangeArray.map((dayRangeItem) => {
				return (
					<Day key={`${mode}-${dayRangeItem.month}-${dayRangeItem.fullDate}`} dayRangeItem={dayRangeItem} />
				);
			})}
		</div>
	);
};
